'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { Icon } from '@udemy-v2/icons';
import { BlockList } from '@udemy-v2/react-core-components';
import { getUdemyLogos } from '@udemy-v2/react-brand-components';
import { useFormatNumber, useI18n } from '@udemy-v2/i18n';
import styles from './teams-purchase-content.module.scss';
import { useOrganizationStats } from '@udemy-v2/site-stats';
import { getTeamPlanSeatCount, useTeamSubscriptionPlan } from '@udemy-v2/subscription-graphql';
import { UFBNoticeButton } from '@udemy-v2/organization-growth';
import { useUbCtaParams } from '@/features/course-landing-page/hooks/use-ub-cta-href';
import classNames from 'classnames';
export const TeamsPurchaseContent = t0 => {
  const $ = _c(34);
  const {
    premiumCourseNotice
  } = t0;
  const {
    gettext,
    interpolate,
    locale
  } = useI18n();
  const {
    formatNumber
  } = useFormatNumber();
  const {
    numCoursesRounded
  } = useOrganizationStats();
  const formattedNumCoursesRounded = formatNumber(numCoursesRounded);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getUdemyLogos();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const udemyLogos = t1;
  const {
    ubHref
  } = useUbCtaParams();
  const teamSubscriptionPlan = useTeamSubscriptionPlan();
  const teamPlanMinimumSeatCount = getTeamPlanSeatCount(teamSubscriptionPlan);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={styles.logo}><Image src={udemyLogos.ubLogoUrl} width={180} height={40} alt="Udemy Business" /></div>;
    t3 = classNames("ud-text-sm", styles.description);
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== locale || $[4] !== ubHref) {
    t4 = {
      locale,
      placement: "TeamsPurchaseContent",
      url: ubHref
    };
    $[3] = locale;
    $[4] = ubHref;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4 || $[7] !== ubHref) {
    t5 = <UFBNoticeButton className={styles.button} href={ubHref} size="large" eventData={t4} />;
    $[6] = t4;
    $[7] = ubHref;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const T0 = BlockList;
  const t6 = styles;
  const t7 = "small";
  const t8 = "tight";
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Icon glyph="tick" label={false} className={styles["checkbox-icon"]} />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const t10 = interpolate(gettext("For teams of %(minUsers)s or more users"), {
    minUsers: teamPlanMinimumSeatCount ?? "2"
  }, true);
  let t11;
  if ($[10] !== t10) {
    t11 = <BlockList.Item icon={t9}>{t10}</BlockList.Item>;
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const t12 = BlockList;
  let t13;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Icon glyph="tick" label={false} className={styles["checkbox-icon"]} />;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  const t14 = interpolate(gettext("%(courseCount)s+ fresh & in-demand courses"), {
    courseCount: formattedNumCoursesRounded
  }, true);
  let t15;
  if ($[13] !== t12.Item || $[14] !== t13 || $[15] !== t14) {
    t15 = <t12.Item icon={t13}>{t14}</t12.Item>;
    $[13] = t12.Item;
    $[14] = t13;
    $[15] = t14;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Icon glyph="tick" label={false} className={styles["checkbox-icon"]} />;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] !== gettext) {
    t17 = gettext("Learning Engagement tools");
    $[18] = gettext;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  let t18;
  if ($[20] !== t17) {
    t18 = <BlockList.Item icon={t16}>{t17}</BlockList.Item>;
    $[20] = t17;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Icon glyph="tick" label={false} className={styles["checkbox-icon"]} />;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  let t20;
  if ($[23] !== gettext) {
    t20 = gettext("SSO and LMS Integrations");
    $[23] = gettext;
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  let t21;
  if ($[25] !== t20) {
    t21 = <BlockList.Item icon={t19}>{t20}</BlockList.Item>;
    $[25] = t20;
    $[26] = t21;
  } else {
    t21 = $[26];
  }
  let t22;
  if ($[27] !== T0 || $[28] !== t11 || $[29] !== t15 || $[30] !== t18 || $[31] !== t21 || $[32] !== t6.list) {
    t22 = <T0 className={t6.list} size={t7} padding={t8}>{t11}{t15}{t18}{t21}</T0>;
    $[27] = T0;
    $[28] = t11;
    $[29] = t15;
    $[30] = t18;
    $[31] = t21;
    $[32] = t6.list;
    $[33] = t22;
  } else {
    t22 = $[33];
  }
  return <div className={styles.container}>{premiumCourseNotice && premiumCourseNotice}{t2}<p className={t3}>{interpolate(gettext("Get your team access to %(courseCount)s+ top Udemy courses anytime, anywhere."), {
        courseCount: formattedNumCoursesRounded
      }, true)}</p>{t5}{t22}</div>;
};